export default __webpack_public_path__ + "static/media/Q01_耀眼南島陽光海岸，白沙上海風輕.f1749ef5.mp4";